//2022男神選舉
export { getGameInfo } from "./getGameInfoServices";
export { getAllCandidates } from "./candidatesServices";
export { getCandidatesDetails } from "./candidatesDetailServices";
export { getCandidatesModal } from "./candidatesModalServices";
export { vote } from "./voteServices";
export { logShare } from "./logShareServices";
export { uploadImage } from "./uploadImageServices";
export { singUpForm } from "./singUpFormServices";
